module.exports = __webpack_public_path__ + "img/authenticator.2e226027.png";